import React, { Fragment } from "react";
import { useParams } from "react-router-dom";
//
import { useForm } from "react-hook-form";
//
import { useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
//
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import DialogForm from "components/dialogForm";
import FormField from "components/formField";

export const GET_COOPERATIVE_NAME = gql`
  query GetCooperative($id: ID!) {
    cooperative(id: $id) {
      businessName
    }
  }
`;

export const CREATE_CONTRACT_BUNDLE = gql`
  mutation CreateContractBundle($input: CreateContractBundleInput!) {
    createContractBundle(input: $input) {
      code
      success
      message
    }
  }
`;

export default function() {
  const { id } = useParams();

  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useQuery(GET_COOPERATIVE_NAME, {
    variables: { id }
  });

  const [
    createContractBundle,
    { data: mutationData, loading: mutationLoading, error: mutationError }
  ] = useMutation(CREATE_CONTRACT_BUNDLE);

  const { register, handleSubmit, formState, errors } = useForm({
    //mode: "onChange"
  });

  const onSubmit = data => {
    //const { code, agreementDate, startDate } = data;
    const { } = data;

    const variables = {
      input: {
        cooperative: queryData.cooperative.businessName,
        /*type: code,
        template: "???",
        agreementDate,
        startDate*/
      }
    };

    createContractBundle({
      variables
    });
  };

  if (queryError) return <p>ERROR: {queryError.message}</p>;

  return (
    <Fragment>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={mutationLoading}
        message={"Creazione dei contratti avviata con successo."}
      />
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={Boolean(mutationError)}
        message={"Si è verificato un errore nella creazione dei contratti."}
      />      
      <DialogForm
        id="create-contract"
        title={
          queryData &&
          `Creazione Contratti ${queryData.cooperative.businessName}`
        }
        subTitle={queryData && `La seguente procedura avvierà la creazione dei contratti per la società ${queryData.cooperative.businessName}, saranno prese in carico tutte le matricole attive e senza l'indicazione di contratto emesso.`}
        buttonTitle='Crea contratti'
        formState={formState}
        onSubmit={handleSubmit(onSubmit)}
      >
          {/* <FormField
            id="code"
            name="code"
            label="Codice"
            type="text"
            inputRef={register({ required: "Inserisci il codice." })}
            error={errors.password}
          />
          <FormField
            id="stip"
            name="agreementDate"
            label="Data stipula"
            type="date"
            inputRef={register({ required: "Inserisci data di stipula." })}
            error={errors.password}
          />
          <FormField
            id="start"
            name="startDate"
            label="Data inizio"
            type="date"
            inputRef={register({ required: "Inserisci data di inizio." })}
            error={errors.password}
          /> */}
      </DialogForm>
    </Fragment>
  );
}
